import styled from "styled-components";

export const FieldHourOfDayContainer = styled.div`
	padding: 1.5em 0;
`;
